import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import Loader from "../../Global/Loader";
import cdpService from "../../../apiService/cdp.service";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const SignInMethodChart = ({ filters = {} }) => {
  const [signInData, setSignInData] = useState([["Task", "Login Source"]]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSignInMethodData();
  }, [filters]); // Re-fetch data when filters change

  const fetchSignInMethodData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await cdpService.getActionRefChart(filters);

      if (response.data.success) {
        const actionRefData = response.data.data.actionRefData.map((item) => [
          item.action_ref,
          item.action_ref_count,
        ]);

        setSignInData([["Task", "Login Source"], ...actionRefData]);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Generate Random Colors for the Pie Chart
  const PieHoleOption = {
    pieHole: 0.56,
    is3D: false,
    legend: {
      position: "right",
      alignment: "center",
      textStyle: {
        color: "#233238",
        fontSize: 10,
      },
    },
    chartArea: {
      left: 10,
      right: 10,
      bottom: 20,
      top: 20,
      width: "100%",
      height: "100%",
    },
    colors: signInData.length > 1
      ? signInData.slice(1).map(() => getRandomColor()) // Generate random colors for each data point
      : [], // In case there's no data, avoid error
  };

  // Skeleton Loader
  


  if (loading) return <Loader/>;
  if (error) return <p>Error loading data: {error}</p>;

  return (
    <Chart
      chartType="PieChart"
      width="100%"
      height="350px"
      data={signInData}
      options={PieHoleOption}
    />
  );
};

export default SignInMethodChart;
